import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Download } from 'lucide-react';

const ApplicationsTable = ({ applications, language, onStatusChange }) => {
  const handleDownloadCv = async (cvUrl) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${cvUrl}`, { responseType: 'blob' });
      const blobUrl = window.URL.createObjectURL(res.data);
      window.open(blobUrl, '_blank', 'noopener,noreferrer');
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
    } catch (e) {
      toast.error(language === 'sv' ? 'Kunde inte hämta CV' : 'Could not fetch CV');
    }
  };

  return (
  <div className="bg-white border border-stone-200 overflow-hidden">
    <div className="p-4 border-b border-stone-200"><h3 className="text-stone-900 font-semibold">{language === 'sv' ? 'Jobbansökningar' : 'Job Applications'}</h3></div>
    <div className="overflow-x-auto">
      <Table>
        <TableHeader><TableRow className="bg-stone-50"><TableHead>{language === 'sv' ? 'Namn' : 'Name'}</TableHead><TableHead>Email</TableHead><TableHead>CV</TableHead><TableHead>Status</TableHead><TableHead className="text-right">{language === 'sv' ? 'Datum' : 'Date'}</TableHead></TableRow></TableHeader>
        <TableBody>
          {applications.length === 0 ? <TableRow><TableCell colSpan={5} className="text-center text-stone-500 py-8">{language === 'sv' ? 'Inga ansökningar' : 'No applications'}</TableCell></TableRow> : applications.map((app) => (
            <TableRow key={app.id} className="hover:bg-stone-50">
              <TableCell className="font-medium">{app.first_name} {app.last_name}</TableCell>
              <TableCell>{app.email}</TableCell>
              <TableCell>{app.cv_url ? <Button variant="ghost" size="sm" data-testid={`download-cv-${app.id}`} onClick={() => handleDownloadCv(app.cv_url)}><Download className="w-4 h-4 mr-1" /> CV</Button> : '-'}</TableCell>
              <TableCell><Select value={app.status} onValueChange={(s) => onStatusChange(app.id, s)}><SelectTrigger className="w-32 bg-white border-stone-300"><SelectValue /></SelectTrigger><SelectContent className="bg-white"><SelectItem value="new">New</SelectItem><SelectItem value="reviewing">Reviewing</SelectItem><SelectItem value="interviewed">Interviewed</SelectItem><SelectItem value="accepted">Accepted</SelectItem><SelectItem value="rejected">Rejected</SelectItem></SelectContent></Select></TableCell>
              <TableCell className="text-right text-stone-500 text-sm">{new Date(app.created_at).toLocaleDateString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  </div>
  );
};

export default ApplicationsTable;
